import DOMPurify from 'isomorphic-dompurify';
import React from 'react';

export interface HtmlWrapperProps {
  content: string;
}
export const HtmlWrapper = ({ content = '', ...props }: HtmlWrapperProps) => {
  const cleanContent = DOMPurify.sanitize(content);
  return <span dangerouslySetInnerHTML={{ __html: cleanContent }} {...props} />;
};
